<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="4" />
    <div class="mb-3">
      <h4>Estado de Facturas</h4>
    </div>
    <hr>

    <!-- Filtros rápidos -->
    <div class="mb-3 d-flex flex-wrap gap-2">
      <button class="btn btn-sm btn-outline-primary"   @click="setToday">Hoy</button>
      <button class="btn btn-sm btn-outline-secondary" @click="setThisMonth">Mes Actual</button>
      <button class="btn btn-sm btn-outline-success"   @click="setThisQuarter">Trimestre Actual</button>
      <button class="btn btn-sm btn-outline-info"      @click="setThisSemester">Semestre Actual</button>
      <button class="btn btn-sm btn-outline-warning"   @click="setThisYear">Año Actual</button>
    </div>

    <!-- Rango de fechas + Consultar + CSV -->
    <div class="input-group mb-3">
      <span class="input-group-text">Desde</span>
      <input type="date" class="form-control" v-model="fechaDesde" />
      <span class="input-group-text">Hasta</span>
      <input type="date" class="form-control" v-model="fechaHasta" />
      <button
        class="btn btn-dark"
        @click="fetchFacturas"
        :disabled="!fechaDesde || !fechaHasta || cargando"
      >
        <span v-if="cargando" class="spinner-border spinner-border-sm me-1"></span>
        Consultar
      </button>
      <button
        class="btn btn-success"
        @click="exportToCSV"
        :disabled="!facturasAgrupadas.length"
      >
        <span class="material-symbols-outlined align-middle" style="font-size:16px">download</span>
        CSV
      </button>
    </div>

    <div v-if="facturasAgrupadas.length">
      <!-- ── KPIs ── -->
      <div class="row g-3 mb-4">
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Total facturas</div>
            <div class="kpi-value">{{ totalCantidad.toLocaleString() }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Monto total</div>
            <div class="kpi-value kpi-value--sm">{{ formatMoneda(totalMonto) }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Estados distintos</div>
            <div class="kpi-value">{{ facturasAgrupadas.length }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Estado predominante</div>
            <div class="kpi-value kpi-value--sm">{{ estadoPredominante }}</div>
          </div>
        </div>
      </div>

      <!-- ── Estado cards ── -->
      <div class="row g-3 mb-4">
        <div
          v-for="f in facturasAgrupadas" :key="f.estadoFactura"
          class="col-6 col-md"
          style="min-width:140px"
        >
          <div
            class="estado-card"
            :class="`estado-card--${f.estadoFactura.toLowerCase()}`"
            @click="verDetalle(f.estadoFactura)"
            title="Ver detalle"
          >
            <div class="estado-card__label">{{ f.estadoFactura }}</div>
            <div class="estado-card__count">{{ f.cantidad }}</div>
            <div class="estado-card__monto">{{ formatMoneda(f.total) }}</div>
            <div class="estado-card__pct">{{ porcentajeCantidad(f.cantidad) }}% del total</div>
          </div>
        </div>
      </div>

      <!-- ── Tabs ── -->
      <div class="tabs">
        <button class="tablink" :class="{ 'active-tab': tabActivo === 'tabla' }" @click="tabActivo = 'tabla'">
          <span class="material-symbols-outlined" style="font-size:17px">table_view</span>
          Tabla
        </button>
        <button class="tablink" :class="{ 'active-tab': tabActivo === 'grafico' }" @click="tabActivo = 'grafico'">
          <span class="material-symbols-outlined" style="font-size:17px">pie_chart</span>
          Gráfico
        </button>
      </div>

      <!-- Tab Tabla -->
      <div v-if="tabActivo === 'tabla'" class="mt-3">
        <table class="table table-bordered table-hover table-sm">
          <thead class="table-dark">
            <tr>
              <th class="sortable" @click="ordenar('estadoFactura')">
                Estado
                <span class="material-symbols-outlined sort-icon">
                  {{ sortKey === 'estadoFactura' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </span>
              </th>
              <th class="text-end sortable" @click="ordenar('cantidad')">
                Cantidad
                <span class="material-symbols-outlined sort-icon">
                  {{ sortKey === 'cantidad' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </span>
              </th>
              <th class="text-end">% Cantidad</th>
              <th class="text-end sortable" @click="ordenar('total')">
                Total
                <span class="material-symbols-outlined sort-icon">
                  {{ sortKey === 'total' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </span>
              </th>
              <th class="text-end">% Monto</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="f in filasSorted" :key="f.estadoFactura"
              class="fila-clickable"
              @click="verDetalle(f.estadoFactura)"
              title="Ver detalle"
            >
              <td>
                <span class="badge" :class="badgeEstado(f.estadoFactura)">
                  {{ f.estadoFactura }}
                </span>
              </td>
              <td class="text-end">{{ f.cantidad }}</td>
              <td class="text-end">
                <div class="d-flex align-items-center justify-content-end gap-2">
                  <div class="pct-bar-wrap">
                    <div class="pct-bar" :style="{ width: porcentajeCantidad(f.cantidad) + '%' }"></div>
                  </div>
                  {{ porcentajeCantidad(f.cantidad) }}%
                </div>
              </td>
              <td class="text-end">{{ formatMoneda(f.total) }}</td>
              <td class="text-end">
                <div class="d-flex align-items-center justify-content-end gap-2">
                  <div class="pct-bar-wrap">
                    <div class="pct-bar pct-bar--teal" :style="{ width: porcentajeMonto(f.total) + '%' }"></div>
                  </div>
                  {{ porcentajeMonto(f.total) }}%
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary fw-bold">
              <td>Total ({{ facturasAgrupadas.length }} estados)</td>
              <td class="text-end">{{ totalCantidad }}</td>
              <td class="text-end">100%</td>
              <td class="text-end">{{ formatMoneda(totalMonto) }}</td>
              <td class="text-end">100%</td>
            </tr>
          </tfoot>
        </table>
        <small class="text-muted">
          <span class="material-symbols-outlined align-middle" style="font-size:14px">touch_app</span>
          Haz clic en una fila para ver el detalle
        </small>
      </div>

      <!-- Tab Gráfico -->
      <div v-if="tabActivo === 'grafico'" class="mt-3">
        <apexchart
          type="pie"
          :options="chartOptions"
          :series="seriesMonto"
          height="420"
        />
      </div>
    </div>

    <div v-else-if="consultado" class="alert alert-info mt-3">
      No hay datos para el período seleccionado.
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout        from '@/components/Layout.vue'
import Footer        from '@/components/Footer.vue'
import VueApexCharts from 'vue3-apexcharts'
import api           from '@/services/api'

const COLORES = {
  PENDIENTE: '#fbbf24',
  EMITIDA:   '#3b82f6',
  PARCIAL:   '#a78bfa',
  PAGADA:    '#10b981',
  ANULADA:   '#f87171',
}

export default {
  name: 'AgrupadosEstadoFactura',
  components: { Layout, Footer, apexchart: VueApexCharts },

  data() {
    return {
      fechaDesde: '',
      fechaHasta: '',
      facturas:   [],
      tabActivo:  'tabla',
      cargando:   false,
      consultado: false,
      sortKey:    'cantidad',
      sortDir:    'desc',
    }
  },

  computed: {
    facturasAgrupadas() {
      const mapa = {}
      this.facturas.forEach(f => {
        const estado = f.estadoFactura ?? 'SIN ESTADO'
        if (!mapa[estado]) mapa[estado] = { estadoFactura: estado, cantidad: 0, total: 0 }
        mapa[estado].cantidad++
        mapa[estado].total += f.total ?? 0
      })
      return Object.values(mapa).sort((a, b) => a.estadoFactura.localeCompare(b.estadoFactura))
    },
    filasSorted() {
      return [...this.facturasAgrupadas].sort((a, b) => {
        const av = a[this.sortKey]
        const bv = b[this.sortKey]
        if (av < bv) return this.sortDir === 'asc' ? -1 : 1
        if (av > bv) return this.sortDir === 'asc' ? 1 : -1
        return 0
      })
    },
    totalCantidad() {
      return this.facturasAgrupadas.reduce((t, f) => t + f.cantidad, 0)
    },
    totalMonto() {
      return this.facturasAgrupadas.reduce((t, f) => t + f.total, 0)
    },
    estadoPredominante() {
      if (!this.facturasAgrupadas.length) return '—'
      return [...this.facturasAgrupadas].sort((a, b) => b.cantidad - a.cantidad)[0].estadoFactura
    },
    seriesMonto() {
      return this.facturasAgrupadas.map(f => f.total)
    },
    chartOptions() {
      return {
        chart:   { type: 'pie', toolbar: { show: false }, fontFamily: 'inherit' },
        labels:  this.facturasAgrupadas.map(f => f.estadoFactura),
        colors:  this.facturasAgrupadas.map(f => COLORES[f.estadoFactura] ?? '#94a3b8'),
        legend:  { position: 'bottom', fontSize: '13px' },
        tooltip: { y: { formatter: val => this.formatMoneda(val) } },
        responsive: [{
          breakpoint: 480,
          options: { chart: { width: 300 }, legend: { position: 'bottom' } },
        }],
      }
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleFacturacion()
    this.$refs.layoutRef.toggleAyuda()
  },

  methods: {
    formatMoneda(valor) {
      return new Intl.NumberFormat('es-EC', {
        style: 'currency', currency: 'USD', minimumFractionDigits: 2,
      }).format(valor ?? 0)
    },

    badgeEstado(estado) {
      const clases = {
        PENDIENTE: 'badge-pendiente',
        EMITIDA:   'badge-emitida',
        PARCIAL:   'badge-parcial',
        PAGADA:    'badge-pagada',
        ANULADA:   'badge-anulada',
      }
      return clases[estado] ?? 'bg-secondary'
    },

    porcentajeCantidad(valor) {
      if (!this.totalCantidad) return 0
      return ((valor / this.totalCantidad) * 100).toFixed(1)
    },

    porcentajeMonto(valor) {
      if (!this.totalMonto) return 0
      return ((valor / this.totalMonto) * 100).toFixed(1)
    },

    ordenar(key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortDir = key === 'estadoFactura' ? 'asc' : 'desc'
      }
    },

    // ── Atajos de fecha ──────────────────────────────────────────────────
    setPeriod(desde, hasta) {
      this.fechaDesde = desde
      this.fechaHasta = hasta
      this.fetchFacturas()
    },
    setToday() {
      const t = new Date().toISOString().split('T')[0]
      this.setPeriod(t, t)
    },
    setThisMonth() {
      const d = new Date()
      this.setPeriod(
        new Date(d.getFullYear(), d.getMonth(),     1).toISOString().split('T')[0],
        new Date(d.getFullYear(), d.getMonth() + 1, 0).toISOString().split('T')[0]
      )
    },
    setThisQuarter() {
      const d = new Date(), q = Math.floor(d.getMonth() / 3)
      this.setPeriod(
        new Date(d.getFullYear(), q * 3,     1).toISOString().split('T')[0],
        new Date(d.getFullYear(), q * 3 + 3, 0).toISOString().split('T')[0]
      )
    },
    setThisSemester() {
      const d = new Date(), s = Math.floor(d.getMonth() / 6)
      this.setPeriod(
        new Date(d.getFullYear(), s * 6,     1).toISOString().split('T')[0],
        new Date(d.getFullYear(), s * 6 + 6, 0).toISOString().split('T')[0]
      )
    },
    setThisYear() {
      const y = new Date().getFullYear()
      this.setPeriod(`${y}-01-01`, `${y}-12-31`)
    },

    // ── API ──────────────────────────────────────────────────────────────
    async fetchFacturas() {
      if (!this.fechaDesde || !this.fechaHasta) return
      this.cargando   = true
      this.consultado = false
      try {
        const idEmpresa = window.sessionStorage.getItem('idEmpresa')
        const { data }  = await api.get(`/vwfacturas/idempresa/${idEmpresa}`, {
          params: { fechaDesde: this.fechaDesde, fechaHasta: this.fechaHasta },
        })
        this.facturas = data ?? []
      } catch (e) {
        console.error('Error fetching facturas:', e)
        this.facturas = []
      } finally {
        this.cargando   = false
        this.consultado = true
      }
    },

    // ── Navegación ───────────────────────────────────────────────────────
    verDetalle(estadoFactura) {
      this.$router.push({
        name:   'DetalleEstadoFactura',
        params: { p_estadofactura: estadoFactura },
        state:  { fechaDesde: this.fechaDesde, fechaHasta: this.fechaHasta },
      })
    },

    // ── Exportar CSV ─────────────────────────────────────────────────────
    exportToCSV() {
      const filas = [
        ['Estado', 'Cantidad', '% Cantidad', 'Total', '% Monto'],
        ...this.filasSorted.map(f => [
          f.estadoFactura,
          f.cantidad,
          `${this.porcentajeCantidad(f.cantidad)}%`,
          this.formatMoneda(f.total),
          `${this.porcentajeMonto(f.total)}%`,
        ]),
        ['Total', this.totalCantidad, '100%', this.formatMoneda(this.totalMonto), '100%'],
      ]
      const csv  = filas.map(r => r.join(';')).join('\n')
      const blob = new Blob([csv], { type: 'text/csv' })
      const url  = URL.createObjectURL(blob)
      const a    = Object.assign(document.createElement('a'), {
        href: url, download: 'Reporte_Estado_Facturas.csv',
      })
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
  },
}
</script>

<style scoped>
/* ── KPIs ── */
.kpi-card {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 14px 18px;
  text-align: center;
}
.kpi-label {
  font-size: 0.75rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: .04em;
  margin-bottom: 4px;
}
.kpi-value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #0d6efd;
  line-height: 1.1;
}
.kpi-value--sm { font-size: 1rem; font-weight: 700; color: #0d6efd; }

/* ── Estado cards ── */
.estado-card {
  border-radius: 10px;
  padding: 14px 16px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  border: 1px solid transparent;
}
.estado-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0,0,0,.1);
}
.estado-card__label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  margin-bottom: 6px;
}
.estado-card__count {
  font-size: 1.8rem;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 2px;
}
.estado-card__monto  { font-size: 0.82rem; font-weight: 600; margin-bottom: 4px; }
.estado-card__pct    { font-size: 0.7rem; opacity: .75; }
.estado-card--pendiente { background: #fef3c7; color: #92400e; border-color: #fde68a; }
.estado-card--emitida   { background: #dbeafe; color: #1e40af; border-color: #bfdbfe; }
.estado-card--parcial   { background: #ede9fe; color: #5b21b6; border-color: #ddd6fe; }
.estado-card--pagada    { background: #d1fae5; color: #065f46; border-color: #a7f3d0; }
.estado-card--anulada   { background: #fee2e2; color: #991b1b; border-color: #fecaca; }

/* ── Tabs ── */
.tabs {
  display: flex;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
}
.tablink {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  background: transparent;
  color: #6c757d;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px 6px 0 0;
  transition: all 0.2s ease;
}
.tablink:hover { color: #0d6efd; background: #f0f4ff; }
.active-tab    { color: #0d6efd; border-bottom-color: #0d6efd; background: #fff; font-weight: 600; }

/* ── Tabla ── */
.sortable { cursor: pointer; user-select: none; white-space: nowrap; }
.sortable:hover { background: #495057; }
.sort-icon { font-size: 14px; vertical-align: middle; opacity: .7; }
.fila-clickable { cursor: pointer; }

/* ── Barras de porcentaje ── */
.pct-bar-wrap {
  width: 60px;
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
}
.pct-bar {
  height: 100%;
  background: #0d6efd;
  border-radius: 3px;
  transition: width 0.4s ease;
}
.pct-bar--teal { background: #20c997; }

/* ── Badges ── */
.badge           { font-size: 0.75rem; padding: 4px 10px; border-radius: 20px; font-weight: 600; }
.badge-pendiente { background: #fef3c7; color: #92400e; }
.badge-emitida   { background: #dbeafe; color: #1e40af; }
.badge-parcial   { background: #ede9fe; color: #5b21b6; }
.badge-pagada    { background: #d1fae5; color: #065f46; }
.badge-anulada   { background: #fee2e2; color: #991b1b; }
</style>